import { AppState } from '../../reducers';

export const isServiceTicketSavingSelector = (state: AppState) =>
  state.connectWise?.serviceTicket?.isServiceTicketSaving ?? false;
